import { render, staticRenderFns } from "./stockTakingOne.vue?vue&type=template&id=5583ef9a&scoped=true"
import script from "./stockTakingOne.vue?vue&type=script&lang=js"
export * from "./stockTakingOne.vue?vue&type=script&lang=js"
import style0 from "./stockTakingOne.vue?vue&type=style&index=0&id=5583ef9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5583ef9a",
  null
  
)

export default component.exports